<template>
    <DatatablePageLayout>
        <template v-slot:datatable>
            <DataTable
                :config="datatableConfig"
                :elements="users"
                :stripe="true"
                :draggable="false"
                :sst="true"
                :pagination="pagination"
                @filter="handleFilter"
                @action="handleAction"
            />
        </template>
    </DatatablePageLayout>
</template>

<script>

import DataTable from '@/modules/Shared/Components/table/SKDataTable.vue'
import loader from "@/modules/Shared/Mixins/loader";
import PaginationService from "@/modules/Shared/Services/PaginationService";
import UsersService from "@/modules/Admin/Services/UsersService";
import DatatablePageLayout from "@/modules/Shared/Pages/DatatablePageLayout.vue";
import CommunityService from "@/modules/Admin/Services/CommunityService";
import {unifyPaginatedResponse} from "@/modules/Shared/Helpers/apiResponseHelper";

export default {
  name: "ClientUsersPage",
  components: {DatatablePageLayout, DataTable},
  mixins: [loader],
  data() {
    return {
      users: [],
      communities: [],
      datatableConfig: [],
      pagination: {},
      presetFilters: [
          {field: 'type', value: 'client'},
          {field: 'credential', value: '0'}
      ]
    }
  },
  async created() {
      this.communities = await unifyPaginatedResponse(CommunityService.getCommunities)

      this.datatableConfig = [
          { 'field' : 'avatar', type: 'image', head : this.$t('profile.label.avatar'), 'searchable' : false, 'sortable' : false},
          { 'field' : 'id', head : this.$t('shops.id'), 'searchable' : true, 'sortable' : false},
          { 'field' : 'uuid_table', head : 'uuid', 'searchable' : true, 'sortable' : false},
          { 'field' : 'username', head : this.$t('apps.registered-users.username'), 'searchable' : true, 'sortable' : false},
          { 'field' : 'email', head : this.$t('apps.registered-users.email'), 'searchable' : true, 'sortable' : false},
          { 'field' : 'community_uuid',
              head : 'community',
              'searchable' : true,
              searchableoptions: this.communities.map(c => ({ value: c.uuid, label: c.name })),
              options: this.communities.map(c => ({ value: c.uuid, label: c.name })),
              'sortable' : false
          },
          { 'field' : 'actions', 'type': 'actions', head : this.$t("geofences.geofences-messages.actions"), 'searchable' : false, 'sortable' : false }
      ]

      await this.getUsers({
          filters: this.presetFilters,
          page: 1
      })
  },
  methods: {
      async getUsers(params) {
          await this.load(async () => {
              const users = await UsersService.getUsers(PaginationService.parseParameters(params))
              this.users =  this.parseUsers(users.data)
              this.pagination = {
                  per_page: users.per_page,
                  total: users.total
              }
          })
      },
      async handleFilter(params) {
          await this.getUsers(
              {
                  filters: [
                      ...params.filters,
                      ...this.presetFilters,
                  ],
                  page: params.page
              }
          )
      },
      async handleAction(type, uuid){
          switch(type) {
              case 'view':
                  await this.$router.push({
                      name: 'admin-client-user-detail',
                      params: {
                          'uuid': uuid,
                      }
                  });
                  break;
              case 'delete':
                  await this.deleteUser(uuid)
                  break;
          }
      },
      async deleteUser(uuid) {
          await this.loadAndNotify(async () => {
              await UsersService.deleteUser(uuid)
              await this.getUsers({
                  filters: this.presetFilters,
                  page: 1
              })
          })
      },
      parseUsers(users) {
          return users.map(user => ({
              ...user,
              avatar: user.avatar || 'https://userdatacf.skitude.com/images/photo_profile.png',
              uuid_table: user.uuid.slice(0, 8) + '...',
              community_uuid: this.communities.find(c => c.uuid === user.community_uuid).name,
              actions: [ 'view', 'delete' ]
          }))
      }
  }
};
</script>
